<template>
  <div
    class="messenger-dialogs"
    :key="superKey"
  >
    <div class="messenger-dialogs__list">
      <!-- Dialog -->
      <div
        v-for="dialog in allClients"
        :key="dialog.client_id"
        class="messenger-dialog"
        :class="{
          'is-active': dialog.client_id === currentClient.client_id,
          'is-assigned': dialog.is_assigned_by_you
        }"
        @click.prevent="handleClickOnDialog(dialog)"
      >
        <div class="messenger-dialog__preview">
          <div class="messenger-dialog-avatar">
            <div class="messenger-dialog-avatar__client">
              <vx-tooltip
                v-if="dialog.profile_image_url"
                :text="dialog.name"
              >
                <vs-avatar
                  :src="dialog.profile_image_url"
                  :text="dialog.name"
                  size="44px"
                  style="margin: 0"
                />
              </vx-tooltip>
            </div>
            <div
              v-if="dialog.operator"
              class="messenger-dialog-avatar__operator"
            >
              <vx-tooltip :text="dialog.operator.name">
                <vs-avatar
                  :src="dialog.operator.profile_image_url ? dialog.operator.profile_image_url : ''"
                  :text="dialog.operator.name"
                  size="30px"
                  style="margin: 0"
                />
              </vx-tooltip>
            </div>
          </div>
        </div>
        <div class="messenger-dialog__description">
          <div class="messenger-dialog-title">
            <div class="messenger-dialog-title__name">{{ dialog.name }}</div>
            <div class="messenger-dialog-title__icon">
              <chat-logo
                :chat-name="dialog.transport_type"
                :size="'xs'"
              />
            </div>
          </div>
          <div class="messenger-dialog-last-message">
            <span v-if="dialog.message_type === 'text'">{{ dialog.body }}</span>
            <span v-if="dialog.message_type === 'file'">(Файл)</span>
            <span v-if="dialog.message_type === 'image'">(Изображение)</span>
            <span v-if="dialog.message_type === 'location'">(Локация)</span>
          </div>
        </div>
        <div class="messenger-dialog__info">
          <div v-if="dialog.unread_count" class="messenger-dialog-badge">{{ dialog.unread_count }}</div>
          <div v-else class="messenger-dialog-date">{{ dialog.created_at | messageDateAndTime }}</div>
        </div>
      </div>
      <infinite-loading
        @infinite="fetchDialogs"
      />
    </div>
    <div class="messenger-dialogs__bottom">
      <button-add-client />
    </div>
  </div>
</template>

<script>
import ButtonAddClient from './ButtonAddClient.vue'
import ChatLogo from '../components/ChatLogo.vue'
import Conversation from '@/api/http/models/Conversation'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    ButtonAddClient,
    ChatLogo
  },
  data () {
    return {
      superKey: 0,
      hasLoaded: false,
      dialogs: [],
      page: 1
    }
  },

  computed: {
    ...mapGetters(['authUserCompany', 'liveChannel', 'currentClient', 'allClients', 'currentNotification'])
  },

  watch: {
    '$route.query': {
      deep: true,
      handler (newValue, oldValue) {
        if (
          newValue.search !== oldValue.search
          || newValue.tags !== oldValue.tags
        ) {
          this.page = 1
          this.refreshDialogs()
        }
      }
    },
    'currentNotification': {
      deep: true,
      handler (newNotification) {
        if (
          typeof newNotification.notification_type === 'undefined'
          || newNotification.notification_type === 'conversation'
        ) {
          this.updateDialogs(newNotification)
        }

        // todo: обновить кол-во непрочитанных сообщений
        // if (dialog.notification_type === 'unread_messages') {
        //   this.updateUnreadMessagesCounter(dialog)
        // }
      }
    }
  },

  methods: {
    ...mapActions(['setClients', 'addClient', 'updateDialog', 'setCurrentClient', 'clearClients']),

    refreshDialogs () {
      this.clearClients()
      this.hasLoaded = false
      this.superKey = this.superKey ? 0 : 1
    },

    async fetchDialogs ($state) {
      const search = this.$route.query.search || ''
      const tags = this.$route.query.tags || ''

      const response = await Conversation.getAll(this.authUserCompany.slug, this.page, search, tags)

      if (response.data) {
        if (response.data.length > 0) {
          response.data.forEach(dialog => {
            this.addClient(dialog)
          })
        } else {
          this.$emit('not-found', true)
        }
      } else if (response.errors) {
        this.$vs.notify({
          color: 'danger',
          title: 'Диалоги не найдены',
          text: ''
        })
      }

      const clientId = Number.parseInt(this.$route.params.client_id, 10)
      if (clientId && !this.currentClient.client_id) {
        this.fetchCurrentClient(clientId)
      }
      if ($state) {
        if (response.meta.current_page === response.meta.last_page) {
          $state.complete()
        } else {
          this.page += 1
          $state.loaded()
        }
      }

      this.hasLoaded = true
    },

    async fetchCurrentClient (clientId) {
      const response = await Conversation.getOne(this.authUserCompany.slug, clientId)

      if (response.data) {
        this.setCurrentClient(response.data)
      }
    },

    async handleClickOnDialog (dialog) {
      if (this.currentClient.client_id !== dialog.client_id) {
        this.fetchCurrentClient(dialog.client_id)
        this.$router.push({
          name: 'chats',
          params: {
            client_id: dialog.client_id
          },
          query: {
            ...this.$route.query
          }
        })
      }
    },

    updateDialogs (dialog) {
      this.updateDialog(dialog)

      // Обновить в истории, если это текущий диалог
      if (this.currentClient.client_id === dialog.client_id) {
        this.$emit('change', dialog.client_id)
      }
    }
  }
}
</script>
